import React from 'react';
import styles from './Spinner.module.css';

export default function Spinner({ size = 48, variant = 'primary', className = '' }) {
    return (
        <span
            className={`${styles.spinner} ${styles[variant]} ${className}`}
            style={{ width: size, height: size }}
            role="status"
            aria-label="Carregando"
        />
    );
}
